import React from "react";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, IconButton } from "@mui/material";
import useStyles from "./modalStyles";
import DeleteModalIcon from "../../assets/images/Svg/DeleteModalIcon";
import VerificationIcon from "../../assets/images/payment-icon/verification-icon.svg";

const ModalHeader = ({ type, onClose }) => {
  const styles = useStyles();
  let Icon = DeleteModalIcon;

  if (type === "info") {
    Icon = () => <img src={VerificationIcon} alt={"info-icon"} />;
  }
  return (
    <Stack
      className={styles.modalHeader}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <div style={{ marginLeft: "calc(55% - 32px)" }}>
        <Icon />
      </div>
      <IconButton className={styles.modalCloseButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
};

ModalHeader.propTypes = {};

export default ModalHeader;
